// extracted by mini-css-extract-plugin
module.exports = {"inputContainer":"styles_inputContainer__M_a7k","confirmCheckbox":"styles_confirmCheckbox__mu7eR"};